import React from 'react';
import '../styles/UpdateNotification.css';

const UpdateNotification = ({ onUpdate, onDismiss }) => {
  return (
    <div className="update-notification-overlay">
      <div className="update-notification-modal">
        <div className="update-notification-icon">
          <i className="fas fa-sync-alt"></i>
        </div>
        <h2>New Update Available</h2>
        <p>A new version of IBV Wealth Club is available. Please update to get the latest features and improvements.</p>
        <div className="update-notification-buttons">
          <button 
            className="update-btn update-now"
            onClick={onUpdate}
          >
            <i className="fas fa-download"></i> Update Now
          </button>
          <button 
            className="update-btn update-later"
            onClick={onDismiss}
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
